<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">代替人信息</div>
      <div class="title">代替人信息</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="150px"
        label-position="left"
        size="mini"
      >
        <el-form-item label="代替人姓名" prop="proxyRealName">
          <el-input v-model="formData.proxyRealName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="代替人身份证号" prop="proxyIdCardNumber">
          <el-input v-model="formData.proxyIdCardNumber" placeholder="请输入" :maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="代替人联系电话" prop="proxyPhoneNumber">
          <el-input v-model="formData.proxyPhoneNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="代替人家庭住址" prop="proxyAddress">
          <el-input v-model="formData.proxyAddress" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="与代替人关系" prop="proxyRelationApply">
          <el-input v-model="formData.proxyRelationApply" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button class="sumbit" @click="saveSumbit()">本人校验</el-button>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <ShareDia :show="shareShow" @dialogClose="shareShow=false" @dialogOpen="shareShow=true"/>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog";
import HeaderImg from "@/components/HeaderImg";
import publicFun from "@/utils/publicFunction";
import ShareDia from "./components/ShareDia";
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    Dialog,
    HeaderImg,
    ShareDia
  },
  computed: {
    status() {
      return this.$store.state.infoStatus;
    }
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "补贴申请", path: "/applySubsidy" },
        { name: "代替人信息" }
      ],
      formData: {
        proxyRealName: "",
        proxyIdCardNumber: "",
        proxyPhoneNumber: "",
        proxyAddress: "",
        proxyRelationApply: ""
      },
      rules: {
        proxyRealName: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        proxyIdCardNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        proxyPhoneNumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        proxyAddress: [
          { required: true, message: "请输入家庭住址", trigger: "blur" }
        ],
        proxyRelationApply: [
          { required: true, message: "请输入关系", trigger: "blur" }
        ]
      },
      shareShow: false
    };
  },
  methods: {
    saveSumbit() {
      // this.shareShow = true;
      this.$refs.form.validate(v => {
        if (v) {
          if (!publicFun.isIdCard(this.formData.proxyIdCardNumber)) {
            return this.$message.error("请输入正确的身份证号");
          }
          if (!publicFun.isPhone(this.formData.proxyPhoneNumber)) {
            return this.$message.error("请输入正确的手机号");
          }
          let data = sessionStore.get("subsidy");
          let params = {
            ...data,
            ...this.formData,
            areaId: this.$store.state.cityArea.areaConfigId
          };
          sessionStore.set("subsidy", params);
          this.$api.apply.subsidyProxy(params).then(res => {
            if (res.code == 1000) {
              this.$router.push({
                name: "applySubsidyFace",
                query: {
                  id: res.data.callbackId
                }
              });
            }
          });
        }
      });
    },
    init() {
      if (sessionStore.get("subsidy")) {
        let data = sessionStore.get("subsidy");
        this.formData = {
          proxyRealName: data.proxyRealName,
          proxyIdCardNumber: data.proxyIdCardNumber,
          proxyPhoneNumber: data.proxyPhoneNumber,
          proxyAddress: data.proxyAddress,
          proxyRelationApply: data.proxyRelationApply
        };
        return
      }
      if (this.$route.query.num == 2) {
        let data = sessionStore.get("subsidyAgain");
        this.formData = {
          proxyRealName: data.proxyRealName,
          proxyIdCardNumber: data.proxyIdCardNumber,
          proxyPhoneNumber: data.proxyPhoneNumber,
          proxyAddress: data.proxyAddress,
          proxyRelationApply: data.proxyRelationApply
        };
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.main-block {
  padding: 35px;
  .title {
    width: 900px;
    line-height: 54px;
    padding-left: 54px;
    margin: 95px auto 0;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #394259;
    background: #f8f9fb;
  }
  .el-form {
    width: 900px;
    padding-left: 50px;
    margin: 20px auto;
    /deep/ .el-form-item {
      .el-input {
        width: 300px;
        input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          padding: 9px 10px;
        }
      }
    }
    .code {
      display: inline-block;
      width: 111px;
      line-height: 27px;
      margin-left: 10px;
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      text-align: center;
      color: #007bff;
      border: 1px solid #007bff;
      border-radius: 2px;
    }
  }
  .btn {
    .el-button {
      border-radius: 2px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}
</style>